import React, { useEffect } from 'react';
import { useOfflineState } from './useOfflineState';
import { useQuickload } from './useQuickload';
import { TrelloOnline } from 'app/src/components/TrelloOnline';
import {
  PreloadStatus,
  useRoutePreloader,
} from 'app/src/components/RoutePreloader';
import { Analytics } from '@trello/atlassian-analytics';
import { cachedFlagValue } from './cachedFlagValue';

export const App = () => {
  const wasEverOffline = useOfflineState();
  const isQuickloading = useQuickload();

  if (wasEverOffline) {
    window.location.href = `/offline?returnUrl=${encodeURIComponent(
      window.location.pathname,
    )}`;
  }

  const isBoardRoutePreloadingEnabled = cachedFlagValue(
    'fep.board_route_preloading',
    false,
  );

  const isCardRoutePreloadingEnabled = cachedFlagValue(
    'fep.card_route_preloading',
    false,
  );

  const isMemberHomeRoutePreloadingEnabled = cachedFlagValue(
    'fep.member_home_route_preloading',
    false,
  );

  const { preloadStatus } = useRoutePreloader({
    isBoardRoutePreloadingEnabled,
    isCardRoutePreloadingEnabled,
    isMemberHomeRoutePreloadingEnabled,
  });

  useEffect(() => {
    if (preloadStatus !== PreloadStatus.PRELOADING) {
      Analytics.sendOperationalEvent({
        action: 'finished',
        actionSubject: 'fetchRouteData',
        source: 'appStartup',
        attributes: {
          reason: preloadStatus,
        },
      });
    }
  }, [preloadStatus]);

  return preloadStatus === PreloadStatus.PRELOADING || isQuickloading ? null : (
    <TrelloOnline />
  );
};
